<!--
 * @Description: 企业开票维护，组件内维护各自状态。工业有客户开票信息。
                 获取、提交以及内部组件的数据处理与平台服务上传发票格式不一样
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseDialog
    width="950px"
    class="form-dialog form-dialog--label120 form-dialog-invoice-custom"
    :title="title"
    :model-value="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <InvoiceOfflineDialogInfo
        ref="infoRef"
        :disabled="offlineType === 1"
        v-model="formData"
      />
      <InvoiceOfflineDialogContent
        ref="contentRef"
        :disabled="offlineType === 1"
        v-model="formData"
      />
      <InvoiceOfflineDialogAddress v-model="formData" />
      <InvoiceOfflineDialogFile
        ref="fileRef"
        :disabled="offlineType === 1"
        v-model="formData"
      />
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="remove">关闭</BaseButton>
      <BaseButton v-if="offlineType === 2" @click="onConfirm">提交</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" name="invoice-enterprise-dialog" setup>
import { withDefaults, defineProps, ref, onMounted, defineEmits } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import { translator } from '@/utils';
import {
  industryDetail,
  industryAddInvoiceApply
} from '@V/invoice/src/data-source/apis';
import { IndustryAddInvoiceApplyParams } from '@V/invoice/src/data-source/types';
import InvoiceOfflineDialogInfo from './invoice-offline-dialog-info.vue';
import InvoiceOfflineDialogContent from './invoice-offline-dialog-content.vue';
import InvoiceOfflineDialogAddress from './invoice-offline-dialog-address.vue';
import InvoiceOfflineDialogFile from './invoice-offline-dialog-file.vue';

type OfflineType = 1 | 2; // 1查看 2编辑/新增

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    id?: number;
    title?: string;
    offlineType: OfflineType;
  }>(),
  {
    id: null,
    title: '发票详情'
  }
);
const emits = defineEmits<{
  (event: 'success', value: void): void;
}>();

const infoRef = ref(null);
const contentRef = ref(null);
const fileRef = ref(null);
const formData = ref<IndustryAddInvoiceApplyParams>({
  invoiceApplyId: null,
  industryId: null,
  industryName: '',
  aspId: null,
  aspName: '',
  invoiceType: null,
  invoiceTypeName: '',
  itemId: null,
  itemName: '',
  invoiceStatus: null,
  openAt: '',
  invoiceAmount: null,
  invoiceTitle: '',
  invoicePhone: '',
  invoiceIdentifierNo: '',
  invoiceOpenBank: '',
  invoiceBankNo: '',
  invoiceEnterpriseAddress: '',
  invoiceApplicationType: null,
  receiptFullName: '',
  receiptPhone: '',
  receiptAddress: '',
  createAt: '',
  authAt: '',
  noPassReason: '',
  invoiceOrderNo: '',
  updateAt: '',
  taskAt: '',
  detailId: null,
  isMail: null,
  companyCode: '',
  companyName: '',
  trackingNo: '',
  importType: null,
  imgList: [],
  fileList: [],
  id: props.id
});

const onConfirm = async () => {
  await Promise.all([
    infoRef.value.validate(),
    contentRef.value.validate(),
    fileRef.value.validate()
  ]);
  await industryAddInvoiceApply({
    ...formData.value,
    invoiceAmount: translator.yuan2fen(formData.value.invoiceAmount),
    imgList: formData.value.imgList.map(item => {
      return {
        ...item,
        ...(item.invoiceAmount && {
          invoiceAmount: translator.yuan2fen(item.invoiceAmount)
        })
      };
    })
  });
  XrkMessage.success('操作成功');
  props.remove();
  emits('success');
};

onMounted(async () => {
  const { id } = props;
  if (id) {
    const { data } = await industryDetail({ id });
    formData.value = {
      id,
      ...data,
      invoiceAmount: data.invoiceAmount
        ? translator.fen2yuan(data.invoiceAmount)
        : null,
      imgList: data.imgList.map(item => {
        return {
          ...item,
          ...(item.invoiceAmount && {
            invoiceAmount: translator.fen2yuan(item.invoiceAmount)
          })
        };
      })
    };
  }
});
</script>
<style lang="scss">
.form-dialog-invoice-custom {
  .form-dialog__title {
    font-weight: 600;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    > h1 {
      text-align: left;
    }
  }
  .form-dialog__content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 16px;
  }
  .form-dialog__w280 {
    width: 100%;
  }
}
</style>
